module.exports = __webpack_public_path__ + "media/images/slack-logo-fcad3e176cd81d2c2d551e9d7f3732ee.jpg";